<template>
  <v-container>
    <v-card>
        <v-card-title>{{ t("agentEarnings.earningsDetails")}}</v-card-title>
        <v-card-text>
            <v-data-table
            :headers="headers"
            :items="incomeDetails"
            class="elevation-1"
            >
            <template v-slot:[`item.type`]="{ item }">
                <span v-if="item.type === 'direct'">{{ t("agentEarnings.directEarnings") }}</span>
                <span v-else-if="item.type === 'indirect'">{{ t("agentEarnings.indirectEarnings") }}</span>
                <span v-else>{{ t("agentEarnings.agentPowerEarnings") }}</span>
            </template>
            </v-data-table>
        </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { fetchAgentEarnings } from '@/api/apiService';
import { useI18n } from 'vue-i18n';
const { t, locale } = useI18n();
const headers = computed(() => {
  const language = locale.value; 
  return [
    { title: t("agentEarnings.time", {language}), value: 'date' },
    { title: t("agentEarnings.purchaseQuantity", {language}), value: 'quantity' },
    { title: t("agentEarnings.purchaseAmount", {language}), value: 'total' },
    { title: t("agentEarnings.withdrawState", {language}), value: "unReward"},
    { title: t("agentEarnings.purchaseUserName", {language}), value: "user_name"},
    { title: t("agentEarnings.earningsAmount", {language}), value: 'amount' },
    { title: t("agentEarnings.earningsType", {language}), value: 'types' }
  ];
});
const incomeDetails = ref([]);

onMounted(async () => {
  const earnings = await fetchAgentEarnings();
  incomeDetails.value = earnings.data.data;
});
</script>

<style>
/* 根据需要添加样式 */
</style> 